import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Link } from '@material-ui/core';
import { TextDecrypt } from '../content/TextDecrypt';
import ResumePDF from './../../assets/Nazeer_Ahmed.pdf';
import {
  ResumeIcon
} from '../content/ResumeButton';

const useStyles = makeStyles((theme) => ({
  footerText: {
    position: 'fixed',
    bottom: theme.spacing(6),
    left: theme.spacing(6),
    '&:hover': {
      color: theme.palette.primary.main,
    },
    transition: 'all 0.5s ease',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },

}));

export const Resume = () => {
  const classes = useStyles();

  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      clearTimeout(timer);
      setIsVisible(true);
      setTimer(setTimeout(() => {
        setIsVisible(false);
      }, 1500));
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, [timer]);

  const handleMouseEnter = () => {
    clearTimeout(timer);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setTimer(setTimeout(() => {
      setIsVisible(false);
    }, 1500));
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isVisible &&
        <Link
          color='inherit'
          underline='none'
          href={`${ResumePDF}`}
          target='_blank'
          rel='noopener noreferrer'
          className={classes.footerText}
        >
          <ResumeIcon />
          Resume
          {/* <Typography component='span'>
        <TextDecrypt text={' Resume'} />
      </Typography> */}
        </Link>
      }
    </div>
  );
};
